/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root'
})
export class AppInterceptorService implements HttpInterceptor {
	isRefreshingToken = false;

	constructor(private router: Router, private apiService: ApiService) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const headers: any = {};
		if (req.url.indexOf("backend-content-storage.s3") < 0) {
			const token: any = localStorage.getItem('vessel_token');
			if (token) {
				headers["Authorization"] = token;
				headers["x-auth-token"] = token;
			}
		}
		const httpRequest = req.clone({
			setHeaders: headers
		})
		return next.handle(httpRequest).pipe(tap({
			/* next: (event) => { }, */
			error: (err) => {
				if (err instanceof HttpErrorResponse) {
					console.log(err)
					if (err.status == 401 || err.status == 403 || err.status == 0) {
						if (req.url.indexOf("login") < 0) {
							this.apiService.navigateToLogin(true);
						}
					}
				}
			}
		}));
	}
}
